import {FIELD_FLAG} from '../../configs/fieldFlags';

/**
 * Волна на ткани флага (см. configs/fieldFlags). Только расчет от часов сцены: флаг
 * пересоздается на каждое обновление стора и машет дальше, не начиная заново.
 */

const TWO_PI = Math.PI * 2;

/**
 * Смещение ткани поперек в точке t: у древка (t = 0) ткань закреплена, на свободном
 * конце (t = 1) размах наибольший
 *
 * @param {number} t — доля длины полотнища
 * @param {number} now — время
 * @param {number} [seed] — у каждого флага своя фаза
 * @returns {number} смещение в единицах поля
 */
export const resolveFlagClothOffset = (t, now, seed = 0) => {
  const {periodMs, waves, amplitude, rippleAmplitude, rippleWaves, ripplePeriodMs} = FIELD_FLAG.wave;
  const part = Math.max(0, t);
  const phase = now / periodMs + seed;
  const ripplePhase = now / ripplePeriodMs + seed * 3;
  const grow = part ** 1.1;
  return grow * amplitude * Math.sin(TWO_PI * (waves * part - phase))
    + grow * rippleAmplitude * Math.sin(TWO_PI * (rippleWaves * part - ripplePhase));
};

/**
 * Свет на ткани в точке t: гребень, повернутый к свету, светлее, впадина темнее
 * @returns {number} от -1 до 1
 */
export const resolveFlagClothLight = (t, now, seed = 0) => {
  const {periodMs, waves} = FIELD_FLAG.wave;
  const part = Math.max(0, t);
  const phase = now / periodMs + seed;
  // Склон волны: четверть периода от самого смещения
  return Math.min(1, part * 4) * Math.cos(TWO_PI * (waves * part - phase));
};

const channel = (color, shift) => (color >> shift) & 0xff;

/**
 * Цвет ткани под этим светом
 * @param {number} color — 0xRRGGBB
 * @param {number} light — от -1 до 1
 * @param {number} lightShare — доля белого на гребне
 * @param {number} darkShare — доля темноты во впадине
 * @returns {number} 0xRRGGBB
 */
export const shadeFlagColor = (color, light, lightShare, darkShare) => {
  const shade = (value) => (light >= 0
    ? value + (255 - value) * lightShare * light
    : value * (1 + darkShare * light));
  return (Math.round(shade(channel(color, 16))) << 16)
    | (Math.round(shade(channel(color, 8))) << 8)
    | Math.round(shade(channel(color, 0)));
};
